export function headerSticky() {
    let mainHeader = document.getElementById('mainHeader');
    let sticky = mainHeader.offsetTop;

    function scrollWatcher() {
        if (window.scrollY  > sticky) {
            mainHeader.classList.add("sticky");
        } else {
            mainHeader.classList.remove("sticky");
        }
    }

    window.addEventListener('scroll', scrollWatcher);
}

export function headerHeightCalc() {
    document.addEventListener('DOMContentLoaded', () => {
        // Get the header element
        const header = document.getElementById('mainHeader');
        if (!header) return;
        // console.log('Header exist')

        /**
         * Updates the CSS variable with current header height
         * Uses requestAnimationFrame for performance optimization
         */
        const updateHeaderHeight = () => {
            // Schedule measurement for the next animation frame
            requestAnimationFrame(() => {
                // Get complete height (content + padding + border)
                const height = header.offsetHeight -1;
                // Set CSS variable on root element
                document.documentElement.style.setProperty('--header-height', `${height}px`);
            });
        };

        // Set initial value on page load
        updateHeaderHeight();

        // Create ResizeObserver to track header dimension changes
        const resizeObserver = new ResizeObserver(entries => {
            // Only update if header is actually resized
            if (!entries[0].contentRect) return;
            updateHeaderHeight();
        });

        // Start observing the header element
        resizeObserver.observe(header);

        // Optimized window resize handler
        let resizeTimeout;
        window.addEventListener('resize', () => {
            // Clear any pending executions
            clearTimeout(resizeTimeout);
            // Throttle updates to maximum once every 100ms
            resizeTimeout = setTimeout(updateHeaderHeight, 100);
        });
    });
}